
export const CommandExecutionType = { ExecuteQuery: 1, ExecuteNonQuery: 2 };

//export default CommandExecutionType;
//export let commandExecutionType = new CommandExecutionType();